import type { NotificationChannel } from '@/types/sturm';

export function findChannel(
  channels: NotificationChannel[],
  id: string,
): NotificationChannel | undefined {
  return channels.find((c) => c.id === id);
}
